<template>
  <div class="box clearfix">
    <div class="topBox">
      <div class="leftArrow" @click="closeWebs"></div>
      <div class="titleName">客服</div>
      <div class="artificialBox" @click="jumpToWeChat">
        <div class="artificialImg" v-if="typeFlag != 'LCXLY'"></div>
        <!-- <div class="artificialTitle">转人工</div> -->
      </div>
    </div>
    <div class="contentBox" ref="contentBox">
      <ul class="questionsAndAnswerList" v-if="historyFlag">
        <li
          v-for="(item, index) in questionsAndAnswersList"
          :key="index"
          class="questionsAndAnswerLi"
        >
          <div class="timeBox">{{ item.createTime }}</div>
          <div class="problemBox">{{ item.problemContent }}</div>
          <div class="problemTypeBox" v-if="item.problemManageVos != null">
            <!-- <div class="problemTypeTop">
              <img
                class="integralImg"
                src="../../assets/images/integralcon.png"
                alt=""
              />
              <div>{{ item.problemContent }}</div>
            </div> -->
            <ul class="problemTypeList">
              <li v-for="(v, i) in item.problemManageVos" :key="i">
                <div>{{ v.problem }}</div>
                <div class="problemTypeImg"></div>
              </li>
            </ul>
          </div>
          <div class="answerBox" v-if="item.problemManageVo != null">
            {{ item.problemManageVo.answer }}
          </div>
          <div
            class="artificialBoxs"
            v-if="item.problemManageVo == null && item.problemManageVos == null && typeFlag != 'LCXLY'"
          >
            <!-- <ul class="artificialList">
              <li>
                <div>人工客服入口在哪里</div>
                <div class="artificialImg"></div>
              </li>
              <li>
                <div>人工客服可以退款吗</div>
                <div class="artificialImg"></div>
              </li>
            </ul> -->
            <div class="artificialBottom">
              <div class="artificialBottomImg"></div>
              转人工
            </div>
          </div>
        </li>
      </ul>
      <div class="welcomeBox">您好，很高兴为您服务。</div>
      <div class="businessBox">
        <div class="businessTop">选择您要咨询的业务</div>
        <ul class="businessList">
          <li
            v-for="(item, index) in businessList"
            :key="index"
            @click="businessClick(item)"
          >
            <div>{{ item.label }}</div>
            <div class="businessImg"></div>
          </li>
        </ul>
      </div>
      <ul class="questionsAndAnswerList">
        <li
          v-for="(item, index) in addProblemList"
          :key="index"
          class="questionsAndAnswerLi"
        >
          <div class="timeBox">{{ item.time }}</div>
          <div class="problemBox">{{ item.label }}</div>
          <div
            class="problemTypeBox"
            v-if="(item.type == 1 || item.type == 2) && item.data.length != 0"
          >
            <!-- <div class="problemTypeTop">
              <img
                class="integralImg"
                src="../../assets/images/integralcon.png"
                alt=""
              />
              <div>{{ item.label }}</div>
            </div> -->
            <ul class="problemTypeList">
              <li
                v-for="(v, i) in item.data"
                :key="i"
                @click="problemTypeClick(v)"
              >
                <div>{{ v.problem }}</div>
                <div class="problemTypeImg"></div>
              </li>
            </ul>
          </div>
          <div class="answerBox" v-if="item.type == 0">
            {{ item.data }}
          </div>
          <div class="artificialBoxs" v-if="item.data.length == 0 && typeFlag != 'LCXLY'">
            <div class="artificialBottom" @click="jumpToWeChat">
              <div class="artificialBottomImg"></div>
              转人工
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="inputBox">
      <div id="ceshi" v-if="false"></div>
      <div id="ss" v-if="false"></div>
      <input
        type="text"
        name="message"
        class="input"
        placeholder="请输入消息"
        v-model="message"
      />
      <button class="buttonBox" @click="btnClick">发送</button>
    </div>
  </div>
</template>

<script>
import { getToken, setToken } from "@/utils/auth";
import {
  directoryList,
  customerList,
  addCustomer,
  listByIdentify,
} from "@/api/artificial/index.js";

export default {
  data() {
    return {
      historyFlag: false,
      pageNumber: 1,
      businessList: [],
      questionsAndAnswersData: [],
      questionsAndAnswersList: [],
      addProblemList: [],
      message: "",
      typeFlag: "",
    };
  },
  mounted() {
    window.getU3dParams = this.getU3dParams;
    // Get the contentBox element
    const contentBox = this.$refs.contentBox;
    let startY;
    let endY;
    let threshold = 50; // Adjust this threshold as needed
    contentBox.addEventListener("touchstart", (e) => {
      startY = e.touches[0].clientY;
    });
    contentBox.addEventListener("touchend", (e) => {
      endY = e.changedTouches[0].clientY;
      let deltaY = endY - startY;
      if (deltaY > threshold) {
        this.handlePullDown();
      }
    });
  },
  created() {
    this.androidIos();
    // this.getDirectoryList();
    // this.getCustomerList();
  },
  // mounted() {
  //   this.$refs.contentBox.addEventListener("scroll", this.handleScroll);
  // },
  methods: {
    getU3dParams(name) {
      const jsonData = JSON.parse(name);
      const token = jsonData.token;
      setToken(token);
      this.typeFlag = jsonData.typeFlag;
      this.$nextTick(() => {
        this.getDirectoryList(token);
        this.$forceUpdate()
      });
    },
    closeWebs() {
      if (this.judgeClient() == "Android") {
        this.closeAndroid();
      } else {
        this.closeIos();
      }
    },
    jumpToWeChat() {
      if (this.judgeClient() == "Android") {
        this.jumpToWeChatAndroid();
      } else {
        this.jumpToWeChatIos();
      }
    },
    androidIos() {
      if (this.judgeClient() == "Android") {
        this.callAndroidFunctionWithParameter();
      } else {
        // window.getU3dParams = this.getU3dParams;
        this.getAppParams();
      }
    },
    judgeClient() {
      let u = navigator.userAgent;
      let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //判断是否是 android终端
      let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //判断是否是 iOS终端
      console.log("是否是Android：" + isAndroid); //true,false
      console.log("是否是iOS：" + isIOS);
      if (isAndroid) {
        return "Android";
      } else if (isIOS) {
        return "IOS";
      } else {
        return "PC";
      }
    },

    callAndroidFunctionWithParameter() {
      // let data = {
      //   rounter: 109 /* int 类型枚举变量 */,
      //   callBack: true /* bool 类型，告诉客户端是否需要回调 */,
      //   params: {},
      // };
      const that = this;
      this.$bridge.callmethod(
        "WebAction.getAppParams",
        { ceshi: "ceshi" },
        (res) => {
          // nativeTunnel为方法名
          // 注意this指向问题
          // alert(res); // 这里能拿到app的返回值哦!
        }
      );
      this.$bridge.registermethod("getU3dParams", (data) => {
        // console.log(data)
        const jsonData = JSON.parse(data);
        const token = jsonData.token;
        this.typeFlag = jsonData.typeFlag;
        // alert(token); // app端给前端的数据在这里
        setToken(token);
        // const storedToken = getToken();
        // console.log("Stored Token:", storedToken); // 在控制台输出存储在 Cookie 中的 token
        // alert("Stored Token: " + storedToken); // 也可以通过 alert 显示
        this.$nextTick(() => {
          this.$nextTick(() => {
            this.getDirectoryList(token);
            this.$forceUpdate()
          });
        });
      });
    },
    closeAndroid() {
      this.$bridge.callmethod(
        "WebAction.closeWeb",
        { ceshi: "ceshi" },
        (res) => {
          // nativeTunnel为方法名
          // 注意this指向问题
          // alert(res); // 这里能拿到app的返回值哦!
        }
      );
    },
    jumpToWeChatAndroid() {
      this.$bridge.callmethod(
        "WebAction.openWxService",
        { ceshi: "ceshi" },
        (res) => {
          // nativeTunnel为方法名
          // 注意this指向问题
          // alert(res); // 这里能拿到app的返回值哦!
        }
      );
    },
    getAppParams() {
      try {
        //使用此方法,会报错,因此使用try-catch
        webkit.messageHandlers.getAppParams.postMessage("js调用ios", (data) => {
          // document.getElementById("ceshi").innerHTML = token;
          // document.getElementById("ss").innerHTML = this.typeFlag;
          //   const jsonData = JSON.parse(data);
          //   const token = jsonData.token;
          //   this.typeFlag = jsonData.typeFlag;
          //   setToken(token);
          //   this.$nextTick(() => {
          //     this.$nextTick(() => {
          //       this.getDirectoryList();
          //     });
          //   });
        });
      } catch (error) {
        console.log("WKWebView post message error: ", error);
      }
    },
    closeIos() {
      try {
        //使用此方法,会报错,因此使用try-catch
        webkit.messageHandlers.closeWeb.postMessage("js调用ios");
      } catch (error) {
        console.log("WKWebView post message error: ", error);
      }
    },
    jumpToWeChatIos() {
      try {
        //使用此方法,会报错,因此使用try-catch
        webkit.messageHandlers.openWxService.postMessage("js调用ios");
      } catch (error) {
        console.log("WKWebView post message error: ", error);
      }
    },
    handlePullDown() {
      this.getCustomerList();
    },
    async getDirectoryList(token) {
      // const token = getToken();
      // document.getElementById("ceshi").innerHTML = token;

      const setList = {
        type: 0,
        identify: this.typeFlag,
      };
      // const token = getToken();
      const { data } = await directoryList(setList, token);
      this.businessList = data.filter((item) => item.pid !== 0);
    },
    async getCustomerList() {
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, "0");
      const day = String(currentDate.getDate()).padStart(2, "0");
      const hours = String(currentDate.getHours()).padStart(2, "0");
      const minutes = String(currentDate.getMinutes()).padStart(2, "0");
      const seconds = String(currentDate.getSeconds()).padStart(2, "0");

      const currentDateTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      const setList = {
        createTime: currentDateTime,
        identify: this.typeFlag,
        pageNum: this.pageNumber,
        pageSize: 10,
      };
      try {
        // const token = getToken();
        const { data } = await customerList(setList);
        const newRecords = data.rows.filter(
          (newRecord) =>
            !this.questionsAndAnswersList.some(
              (existingRecord) => existingRecord.id === newRecord.id
            )
        );

        // 将新记录追加到questionsAndAnswersList后，再按时间顺序排列，然后逆序
        this.questionsAndAnswersList = this.questionsAndAnswersList
          .concat(newRecords)
          .sort((a, b) => new Date(b.createTime) - new Date(a.createTime))
          .reverse();

        if (newRecords.length === 10) {
          this.pageNumber++;
        }
        this.historyFlag = true;
      } catch (error) {
        console.error("Error fetching new data: ", error);
      }
    },
    businessClick(item) {
      const setList = {
        identify: this.typeFlag,
        pid: item.id,
      };
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, "0");
      const day = String(currentDate.getDate()).padStart(2, "0");
      const hours = String(currentDate.getHours()).padStart(2, "0");
      const minutes = String(currentDate.getMinutes()).padStart(2, "0");
      const seconds = String(currentDate.getSeconds()).padStart(2, "0");

      const currentDateTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      listByIdentify(setList).then((res) => {
        if (res.code == 200) {
          console.log("res", res);
          const problemData = {
            label: item.label,
            data: res.data,
            type: 1,
            time: currentDateTime,
          };
          this.addProblemList.push(problemData);
          setTimeout(() => {
            this.$nextTick(() => {
              const contentBox = this.$refs.contentBox;
              if (contentBox) {
                contentBox.scrollTop = contentBox.scrollHeight;
              }
            });
          }, 100); // Adjust the delay as needed
        }
      });
      const setLists = {
        identify: this.typeFlag,
        problemIds: item.id,
        type: 1,
      };
      // const token = getToken();
      addCustomer(setLists).then((res) => {
        console.log(res);
      });
    },
    problemTypeClick(v) {
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, "0");
      const day = String(currentDate.getDate()).padStart(2, "0");
      const hours = String(currentDate.getHours()).padStart(2, "0");
      const minutes = String(currentDate.getMinutes()).padStart(2, "0");
      const seconds = String(currentDate.getSeconds()).padStart(2, "0");
      const currentDateTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      const problemData = {
        label: v.problem,
        data: v.answer,
        type: 0,
        time: currentDateTime,
      };
      this.addProblemList.push(problemData);
      setTimeout(() => {
        this.$nextTick(() => {
          const contentBox = this.$refs.contentBox;
          if (contentBox) {
            contentBox.scrollTop = contentBox.scrollHeight;
          }
        });
      }, 100);
      const setLists = {
        identify: this.typeFlag,
        problemIds: v.id,
        type: 0,
      };
      // const token = getToken();
      addCustomer(setLists).then(async (res) => {
        console.log(res);
      });
    },
    btnClick() {
      const setList = {
        identify: this.typeFlag,
        keyWords: this.message,
      };
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, "0");
      const day = String(currentDate.getDate()).padStart(2, "0");
      const hours = String(currentDate.getHours()).padStart(2, "0");
      const minutes = String(currentDate.getMinutes()).padStart(2, "0");
      const seconds = String(currentDate.getSeconds()).padStart(2, "0");
      const currentDateTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      listByIdentify(setList).then((res) => {
        if (res.code == 200) {
          console.log("res", res);
          const problemData = {
            label: this.message,
            data: res.data,
            type: 2,
            time: currentDateTime,
          };
          this.addProblemList.push(problemData);
          this.message = "";
          const problemIdsList = [];
          problemData.data.forEach((item) => {
            problemIdsList.push(item.id);
          });
          setTimeout(() => {
            this.$nextTick(() => {
              const contentBox = this.$refs.contentBox;
              if (contentBox) {
                contentBox.scrollTop = contentBox.scrollHeight;
              }
            });
          }, 100);
          const setLists = {
            identify: this.typeFlag,
            problemContent: setList.keyWords,
            problemIds: problemIdsList.join(","),
            type: 2,
          };
          // const token = getToken();
          addCustomer(setLists).then((res) => {
            console.log(res);
          });
        }
      });
    },

    // openWxService() {
    //   window.location.href = "openapp://syyxcloud.com";
    // },
  },
};
</script>


<style lang="scss" scoped>
// * {
//   box-sizing: border-box;
//   margin: 0;
//   padding: 0;
// }
.box {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  /* 其他样式规则 */
  .topBox {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 15px 10px 16px;
    width: 100%;
    height: 44px;
    .leftArrow {
      width: 24px;
      height: 24px;
      background: url("~@/assets/images/leftArrow.png") no-repeat;
    }
    .titleName {
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 17px;
      color: #121212;
      line-height: 24px;
      text-align: center;
      font-style: normal;
    }
    .artificialBox {
      display: flex;
      flex-direction: column;
      align-items: center; /* 水平居中 */
      justify-content: center; /* 垂直居中 */
      width: 31px;
      .artificialImg {
        width: 24px;
        height: 24px;
        background: url("~@/assets/images/artificial.png") no-repeat;
        background-size: 100% 100%;
      }
      .artificialTitle {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 10px;
        color: #333333;
        line-height: 14px;
        text-align: center;
        // font-style: normal;
        white-space: normal; /* 或者使用 white-space: pre-wrap; */
      }
    }
  }
  .contentBox {
    .moreBox {
      width: 100%;
      height: 10px;
      background-color: #1bbf8d;
    }
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 16px;
    position: absolute;
    top: 44px;
    left: 0;
    right: 0;
    bottom: 56px;
    padding: 16px;
    background: #f5f5f5;
    overflow-y: auto;
    // text-align: left; /* 左对齐 */
    .welcomeBox {
      display: inline-block; /* 转换为内联块元素 */
      padding: 10px 12px;
      margin-bottom: 16px;
      max-width: 311px; /* 限制最大宽度 */
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #333333;
      line-height: 20px;
      font-style: normal;
      background: #ffffff;
      border-radius: 4px 20px 20px 20px;
    }
    .businessBox {
      padding: 0px 16px 16px 16px;
      margin-bottom: 16px;
      width: 311px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #333333;
      line-height: 20px;
      text-align: left;
      font-style: normal;
      background: #ffffff;
      border-radius: 4px 20px 20px 20px;
      .businessTop {
        height: 40px;
        line-height: 40px;
      }
      .businessList {
        list-style: none;
        li {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 100%;
          height: 34px;
          font-size: 12px;
          border-top: 1px solid #eeeeee;
          .businessImg {
            width: 12px;
            height: 12px;
            background: url("~@/assets/images/rightArrow.png") no-repeat;
          }
        }
      }
    }
    .questionsAndAnswerList {
      width: 100%;
      .questionsAndAnswerLi {
        width: 100%;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        .problemBox {
          display: inline-block; /* 转换为内联块元素 */
          padding: 10px 16px;
          margin-bottom: 16px;
          background: #49dfb1;
          border-radius: 20px 4px 20px 20px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #333333;
          line-height: 20px;
          font-style: normal;
          margin-left: auto; /* 将元素推到右侧，实现向右对齐 */
        }
        .problemTypeBox {
          padding: 16px 16px 16px 16px;
          margin-bottom: 16px;
          width: 311px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 14px;
          color: #333333;
          line-height: 20px;
          text-align: left;
          font-style: normal;
          background: #ffffff;
          border-radius: 4px 20px 20px 20px;
          .problemTypeTop {
            display: flex;
            align-items: center;
            height: 40px;
            font-weight: 500;
            .integralImg {
              margin-right: 6px;
              width: 16px;
              height: 16px;
            }
          }
          .problemTypeList {
            list-style: none;
            li {
              display: flex;
              justify-content: space-between;
              align-items: center;
              width: 100%;
              height: 34px;
              border-bottom: 1px solid #eeeeee;
              .problemTypeImg {
                width: 12px;
                height: 12px;
                background: url("~@/assets/images/rightArrow.png") no-repeat;
              }
            }
          }
        }
        .timeBox {
          width: 100%;
          height: 16px;
          line-height: 16px;
          text-align: center;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 11px;
          color: #aaaaaa;
          font-style: normal;
        }
        .answerBox {
          display: inline-block; /* 转换为内联块元素 */
          padding: 10px 12px;
          margin-bottom: 16px;
          max-width: 311px; /* 限制最大宽度 */
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 12px;
          color: #333333;
          line-height: 20px;
          font-style: normal;
          background: #ffffff;
          border-radius: 4px 20px 20px 20px;
        }
        .artificialBoxs {
          padding: 7px 16px 12px 16px;
          margin-bottom: 16px;
          width: 311px;
          background: #ffffff;
          border-radius: 4px 20px 20px 20px;
          .artificialList {
            list-style: none;
            li {
              display: flex;
              justify-content: space-between;
              align-items: center;
              width: 100%;
              height: 35px;
              font-size: 12px;
              border-bottom: 1px solid #eeeeee;
              .artificialImg {
                width: 12px;
                height: 12px;
                background: url("~@/assets/images/rightArrow.png") no-repeat;
              }
            }
          }
          .artificialBottom {
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 11px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 13px;
            color: #333333;
            text-align: left;
            font-style: normal;
            .artificialBottomImg {
              margin-right: 4px;
              width: 24px;
              height: 24px;
              background: url("~@/assets/images/artificial.png") no-repeat;
              background-size: 100% 100%;
            }
          }
        }
      }
    }
  }
  .inputBox {
    position: fixed;
    left: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    // padding-top: 10px;
    width: 100%;
    height: 56px;
    background: #ffffff;
    .input {
      padding: 9px 14px;
      margin-right: 15px;
      width: 266px;
      height: 36px;
      background: #f8f8f8;
      border-radius: 19px;
      border: none; /* 去掉边框样式 */
      outline: none; /* 去掉点击时的默认边框样式 */
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 13px;
      color: #999999;
      font-style: normal;
    }
    .buttonBox {
      width: 62px;
      height: 36px;
      background: #1bbf8d;
      border-radius: 19px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 13px;
      color: #ffffff;
      line-height: 36px;
      text-align: center;
      font-style: normal;
      border: none; /* 去掉边框样式 */
      outline: none; /* 去掉点击时的默认边框样式 */
    }
  }
}

/* 清除浮动 */
.clearfix::after {
  content: "";
  display: table;
  clear: both;
}
</style>